import React, { CSSProperties } from 'react';

import StraddlePreActionButton from 'components/UserActions/TableActions/StraddlePreActionButton';

import PostBlind from './PostBlindAction';
import WaitForBigBlind from './WaitForBigBlindAction';

import 'components/UserActions/UserActions.scss';

// The join prompt (POST BLIND / WAIT FOR BIG BLIND) renders in the footer's
// centered action slot in BOTH orientations — the same slot the live Fold/Call/
// Raise buttons use — so it sits on the bottom taskbar aligned with the history
// and chat icons. (Landscape previously portaled this to a fixed bar floating
// above the footer, which left it misaligned with those icons.)
//
// EN-11023: the server offers the "straddle next hand" chip to a waiting seat
// too, and from the end of a hand to the next one's set-up such a seat sees this
// row, not PokerActions, so the chip ends this row as it ends that one. It
// renders nothing without an offer.
const JoinActions = () => (
  <div className='player-actions'>
    <div style={actionZIndex} className='poker-actions'>
      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'row',
          gap: '0.35rem',
          width: '100%',
          justifyContent: 'center',
          zIndex: 3
        }}>
        <PostBlind />
        <WaitForBigBlind />
        <StraddlePreActionButton />
      </div>
    </div>
  </div>
);

export default JoinActions;

const actionZIndex: CSSProperties = {
  zIndex: 2
};
